import React, { useEffect, useState } from "react";
import OrderExport from "./ExportToExcel";

function Report() {

    const [list, setList] = useState([]);
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    const item = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/order/getOrderList`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, "error in report api");
        }
    };
    useEffect(() => {
        item();
    }, []);



    return (
        <div className="row" style={{ overflow: "hidden" }}>
            <div className="category" style={{ display: "block", }}>
                <div className="category-nav" >
                    <div className="category-text">
                        <h4>Transaction Report</h4>
                    </div>
                    <div className="category-btn"></div>
                </div>
                <hr />
            </div>
            <div className="filterr">
                <OrderExport orders={list} />
            </div>
        </div>
    )
}
export default Report;